"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  spaceBetweenElements: 16,
  spaceBetweenTitleAndDescription: 6
};